Namespace 'Customer.Sessions'

class Customer.Sessions.SessionExpirationCounter extends Backbone.Model

  initialize:(seconds_left)=>
    @seconds_left = seconds_left
    @hours = 0
    @minutes = 0
    @seconds = 0
    @_calculate_hs_min_secs(seconds_left)
    @counter = setTimeout(@_run,1000)

  _run:() =>
    @trigger('customerSession:counter:finished') if @seconds_left == 0
    if @seconds_left >= 0
      @seconds_left = @seconds_left - 1
      @set(@seconds_left, @seconds_left)
      @_calculate_hs_min_secs(@seconds_left)
    setTimeout(@_run,1000) unless @seconds_left < 0


  _calculate_hs_min_secs:(seconds)->
    totalSeconds = seconds
    hours = Math.floor(totalSeconds / 3600);
    @hours = hours.toString().padStart(2, "0")
    totalSeconds %= 3600;
    minutes = Math.floor(totalSeconds / 60);
    @minutes = minutes.toString().padStart(2, "0")
    seconds = totalSeconds % 60;
    @seconds = seconds.toString().padStart(2, "0")




